import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { LABEL } from './Diff';
import { CountBadge } from './Pills';

export default function ChangeTypeFilter({ activeTypes, onToggle, onClear }) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    useEffect(() => {
        function onMouseDown(e) {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', onMouseDown);
        return () => document.removeEventListener('mousedown', onMouseDown);
    }, []);

    return (
        <Wrap ref={wrapRef}>
            <Btn onClick={() => setOpen(o => !o)} $active={activeTypes.length > 0}>
                Filter changes
                {activeTypes.length > 0 && <CountBadge>{activeTypes.length}</CountBadge>}
            </Btn>
            {open && (
                <Dropdown>
                    <Title>
                        Show changes for
                        {activeTypes.length > 0 && (
                            <Clear onClick={onClear}>Clear</Clear>
                        )}
                    </Title>
                    <Options>
                        {Object.entries(LABEL).map(([k, label]) => (
                            <Chip
                                key={k}
                                $on={activeTypes.includes(k)}
                                onClick={() => onToggle(k)}
                            >
                                {label}
                            </Chip>
                        ))}
                    </Options>
                </Dropdown>
            )}
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
`;

const Btn = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    border-radius: 6px;
    border: 1px solid ${({ $active }) => $active ? '#6366f1' : '#e2e8f0'};
    background: ${({ $active }) => $active ? '#eef2ff' : '#f8fafc'};
    color: ${({ $active }) => $active ? '#6366f1' : '#475569'};
    font-size: 0.75rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 120ms;
    &:hover { background: #eef2ff; border-color: #a5b4fc; color: #6366f1; }
`;


const Dropdown = styled.div`
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    padding: 12px 14px;
    z-index: 50;
    min-width: 220px;
`;

const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.7rem;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 10px;
`;

const Clear = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: 0.7rem;
    font-weight: 600;
    color: #6366f1;
    cursor: pointer;
    text-transform: none;
    letter-spacing: 0;
    &:hover { text-decoration: underline; }
`;

const Options = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
`;

const Chip = styled.button`
    padding: 3px 10px;
    border-radius: 99px;
    border: 1px solid ${({ $on }) => $on ? '#6366f1' : '#e2e8f0'};
    background: ${({ $on }) => $on ? '#ede9fe' : '#f8fafc'};
    color: ${({ $on }) => $on ? '#6366f1' : '#64748b'};
    font-size: 0.72rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 120ms;
    &:hover { border-color: #6366f1; color: #6366f1; background: #ede9fe; }
`;
